import React from "react";
import IPriceProto = space.kenko.proto.IPriceProto;
import {priceToString} from "../../util/PriceUtil";
import {space} from "../../provider_api";
import {ActionButton} from "../../util/UI/ActionButton";

type Props = {
  title: string,
  shortPlanName: 'Growth' | 'Starter'
  price: IPriceProto,
  discountedPrice?: IPriceProto,
  perfectFor: string,
  whatsIncluded: string[],
  highlighted: boolean, // for the recommendation
  onClick: () => void,
}

export const MembershipOption = (props: Props) => {

  return <div className={props.highlighted ? 'MembershipOption Highlighted' : 'MembershipOption'}>
    <h4>{props.title.toUpperCase()}</h4>

    {!props.discountedPrice && <h2>{priceToString(props.price, true)} / mo.</h2>}

    {props.discountedPrice && <h2>
      <span className={'StrikeThroughPrice'}>{priceToString(props.price, true)}</span> 
      {priceToString(props.discountedPrice)} / mo.
    </h2>}
    
    <div><b>Perfect for: </b>{props.perfectFor}</div>
    <div style={{flex: 1}}><b>What's included: </b>
      <ul>{props.whatsIncluded.map(i => <li>{i}</li>)}</ul>
    </div>
    <ActionButton onClick={props.onClick}>Try {props.shortPlanName}</ActionButton>
  </div>
}